// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__UwNWq","imageAndContentWrap":"styles_imageAndContentWrap__xGfR2","contentWrap":"styles_contentWrap__K5sPQ"};